export default __webpack_public_path__ + "static/media/lease_rental_icon.fc44e272.svg";